import { createAction } from 'redux-starter-kit';

export const putVideoOptions = createAction('PUT_VIDEO_OPTIONS');